import React from 'react';
import Select, { Props as ReactSelectProps } from 'react-select';
import { OptionObject } from './ReactSelectInput.types';
import { configReactSelectProps } from 'src/components/ReactSelectInput/ReactSelectInput.utils';

type Props = ReactSelectProps<OptionObject> & {
  removeIcon?: boolean;
  showAllTags?: boolean;
};

//todo: move react-select variants, dependencies and utilities to a single directory.
// now it is scattered between `components/ReactSelectInput` and `components/ui/react-select`

const ReactSelectInput = React.forwardRef<any, Props>(({ removeIcon, showAllTags, ...props }, ref) => {
  const selectProps = configReactSelectProps({ ...props, showAllTags });

  // Remove the chevron icon if removeIcon is true
  if (removeIcon) {
    if (!selectProps.components) selectProps.components = {};
    selectProps.components['DropdownIndicator'] = null;
  }

  return <Select ref={ref} {...selectProps} />;
});

ReactSelectInput.displayName = 'ReactSelectInput';

export default ReactSelectInput;
